var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbSocials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 6.26808 21.7319 0 14 0C6.26808 0 0 6.26808 0 14C0 20.9877 5.11962 26.7797 11.8123 27.83V18.0468H8.2577V14H11.8123V10.9155C11.8123 7.40676 13.9022 5.46858 17.1002 5.46858C18.6321 5.46858 20.2341 5.74188 20.2341 5.74188V9.18726H18.4685C16.7292 9.18726 16.1868 10.2664 16.1868 11.3737V14H20.0696L19.449 18.0468H16.1868V27.83C22.88 26.7797 27.9991 20.9881 27.9991 14H28Z",
    fill: "#F77962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4496 18.0467L20.0702 13.9999H16.1874V11.3736C16.1874 10.2664 16.7298 9.18719 18.4691 9.18719H20.2347V5.74181C20.2347 5.74181 18.6327 5.46851 17.1009 5.46851C13.9028 5.46851 11.8129 7.40669 11.8129 10.9154V13.9999H8.2583V18.0467H11.8129V27.8299C12.5257 27.9417 13.2564 27.9999 14.0006 27.9999C14.7449 27.9999 15.4755 27.9417 16.1883 27.8299V18.0467H19.4505H19.4496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbSocials);
export default __webpack_public_path__ + "static/media/fb-socials.a4b37622bf805ecdd65ce01d96c54d4d.svg";
export { ForwardRef as ReactComponent };